import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu, Loader, Button, Divider, Modal } from 'semantic-ui-react'
import { Switch, Route, NavLink, Redirect } from 'react-router-dom'
import AbsoluteDiv from '@bsd/dashboard-toolkit/components/AbsoluteDiv'

import { DEFAULT_LOCALE } from '../constants'
import { loadGeoCategory, updateGeoCategory, deleteGeoCategory } from '../actions/geoCategories'
import GeoCategoryForm from './GeoCategoryForm'
import GeoCategoryObjectsManager from './GeoCategoryObjectsManager'
import WebCamManager from './WebcamManager'


const CategoryDeleteModal = ({ onDelete, onCancel, geoCategory }) =>
  <Modal open dimmer='inverted'>
    <Modal.Header>Удаление категории</Modal.Header>
    <Modal.Content>
      Действительно удалить категорию {geoCategory.locales[DEFAULT_LOCALE].name}?
    </Modal.Content>
    <Modal.Actions>
      <Button basic icon='delete' content='Отмена' onClick={onCancel}/>
      <Button basic icon='trash' color='red' content='Удалить' onClick={onDelete}/>
    </Modal.Actions>
  </Modal>


class GeoCategory extends React.Component {

  state = {
    loading: false,
    showDeleteModal: false,
  }

  componentDidMount() {
    if (!this.props.geoCategory && !this.state.loading) {
      this.loadCategory()
    }
  }

  loadCategory = async () => {
    this.setState({ loading: true })
    await this.props.loadGeoCategory()
    this.setState({ loading: false })
  }

  showDeleteModal = () => {
    this.setState({ showDeleteModal: true })
  }
  hideDeleteModal = () => {
    this.setState({ showDeleteModal: false })
  }
  handleCategoryDelete = () => {
    this.hideDeleteModal()
    this.props.history.push('/')
    this.props.deleteGeoCategory()
  }

  render() {
    const { showDeleteModal } = this.state
    const { match, geoCategory, updateGeoCategory } = this.props
    if (!geoCategory && this.state.loading) {
      return <Loader active/>
    } else if (!geoCategory) { return <span/> }
    return (
      <AbsoluteDiv>
        <h3>Редактирование категории &laquo;{geoCategory.locales[DEFAULT_LOCALE].name}&raquo;</h3>
        <Menu secondary pointing>
          <Menu.Item as={NavLink} to={`${match.url}/objects`}><Icon name='cubes'/> Объекты</Menu.Item>
          <Menu.Item as={NavLink} to={`${match.url}/webcams`}><Icon name='video camera'/> Камеры</Menu.Item>
          <Menu.Item as={NavLink} to={`${match.url}/settings`}><Icon name='cogs'/> Настройка</Menu.Item>
        </Menu>
        <AbsoluteDiv top='100px'>
          <Switch>
            <Route exact path={`${match.url}/`} render={() => <Redirect to={`${match.url}/objects`}/>}/>
            <Route path={`${match.url}/objects/:geoObjectId?`} render={() =>
              <GeoCategoryObjectsManager geoCategoryId={match.params.categoryId}/>}
            />
            <Route path={`${match.url}/webcams`}>
              <WebCamManager geoCategoryId={match.params.categoryId}/>
            </Route>
            <Route path={`${match.url}/settings`} render={() =>
              <>
                <GeoCategoryForm
                  initialData={geoCategory}
                  onSubmit={updateGeoCategory}
                />
                <Divider/>
                <center>
                  <Button
                    basic size='mini' color='red' icon='trash'
                    content='Удалить категорию'
                    onClick={this.showDeleteModal}
                  />
                </center>
              </>}
            />
          </Switch>
        </AbsoluteDiv>
        {showDeleteModal ?
          <CategoryDeleteModal
            geoCategory={geoCategory}
            onDelete={this.handleCategoryDelete}
            onCancel={this.hideDeleteModal}
          /> : null}
      </AbsoluteDiv>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const categoryId = ownProps.match.params.categoryId
  return {
    geoCategory: state.geoCategories[categoryId] || null,
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  const categoryId = ownProps.match.params.categoryId
  return {
    loadGeoCategory: () => dispatch(loadGeoCategory()),
    updateGeoCategory: (data) => dispatch(updateGeoCategory(categoryId, data)),
    deleteGeoCategory: () => dispatch(deleteGeoCategory(categoryId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GeoCategory)
